import React from 'react'

export const LayoutStyles: { [key: string]: React.CSSProperties } = {
    container: {
        width: '100%',
        height: '100%',
        display: 'flex',
        overflow: 'hidden',
        boxSizing: 'border-box',
    },
    content: {
        width: '100%',
        overflow: 'auto',
        position: 'relative',
        boxSizing: 'border-box',
        backgroundColor: '#fafbfa',
        height: 'calc(100% - 58px)',
    },
    spaces: {
        position: 'relative',
        marginBottom: 25,
        marginRight: 50,
        marginLeft: 50,
        marginTop: 25,
    },
    background: {
        zIndex: 899,
        width: '100%',
        height: '100%',
        position: 'absolute',
        backdropFilter: 'blur(6px)',
        backgroundColor: 'rgba(172, 172, 172, 0.5)',
    },
}
